export const PermissionDataFragment = `
    id
    name
    display_name
    detailed_display_name
    description
    type
`
